import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

export default function DirectAnswer(props) {
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const { Title, Desc } = props.answer ? props.answer : {};

  return (
    <>
      {Title || Desc ? (
        <div
          style={{
            padding: isDesktopOrLaptop
              ? "0 0 45px 341px"
              : "10px 12px 27px 11px",
          }}
        >
          <div
            style={{
              width: isDesktopOrLaptop ? "741px" : "100%",
              display: isDesktopOrLaptop ? "flex" : "",
            }}
          >
            <div
              style={{
                width: isDesktopOrLaptop ? "147px" : "100%",
                height: "172px",
                margin: isDesktopOrLaptop ? "2px 23px 0 0" : "0",
                borderRadius: "10px",
                backgroundColor: "#f8f8f8",
              }}
            ></div>
            <div style={{ width: isDesktopOrLaptop ? "610px" : "100%" }}>
              <Typography
                style={{
                  fontFamily: "Overpass",
                  fontSize: "21px",
                  fontWeight: 900,
                  color: "#16063b",
                  paddingTop: isDesktopOrLaptop ? "0" : "20px",
                }}
              >
                {Title}
              </Typography>
              <Typography
                style={{
                  fontFamily: "Overpass",
                  fontSize: "14px",
                  color: "#808080",
                  lineHeight: 1.87,
                  marginTop: isDesktopOrLaptop ? "17px" : "15px",
                }}
              >
                {Desc}
              </Typography>
            </div>
          </div>
          <div
            style={{
              height: "1px",
              opacity: 0.35,
              backgroundColor: "#808080",
              width: isDesktopOrLaptop ? "757px" : "100%",
              marginTop: isDesktopOrLaptop ? "45px" : "28px",
            }}
          ></div>
        </div>
      ) : null}
    </>
  );
}
